export default "/_next/static/fonts/Graphik-Semibold-b553d5b97ac3ab320b0b4f26f0e3a937.woff2";